(function ($) {
	$(window).on('load', function () {
		let pagetop = '#pagetop';
		let footer = '.site-footer';

		$(pagetop).hide();
		$(footer).css('position', 'relative');

		$(window).on("scroll", function () {
			if ($(this).scrollTop() > 500) {
				$(pagetop).slideDown("fast");
			} else {
				$(pagetop).slideUp("fast");
			}
			let scrollHeight = $(document).height();
			let scrollPosition = $(window).height() + $(window).scrollTop();
			let footHeight = $(footer).innerHeight();
			if (scrollHeight - scrollPosition <= footHeight) {
				$(pagetop).css({//フッターに到達したら
					"position": "absolute",
					"bottom": footHeight + 1
				});
			} else { //フッターに到達する前
				$(pagetop).css({
					"position": "fixed",
					// "bottom": "0"
				});
			}
		});
		$(pagetop).on('click', function () {
			$('body,html').animate({
				scrollTop: 0
			}, 0);
			return false;
		});
	});


document.addEventListener("DOMContentLoaded", function() {
    // ヘッダーの高さを取得する関数を定義
    const getHeaderHeight = () => {
        const header = document.querySelector('#masthead');
        return header ? header.offsetHeight : 0; // ヘッダーが存在しない場合に 0 を返す
    };

    // スクロールして目的のIDに到達させる関数
    const scrollToTarget = (targetElement, headerHeight) => {
        const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - headerHeight;
        window.scrollTo({
            top: targetPosition,
            behavior: "auto"
        });
    };

    // 目的のIDに到達するまで何度もスクロールを実行する関数
    const ensureScrollPosition = (targetElement, headerHeight) => {
        const intervalId = setInterval(() => {
            const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - headerHeight;
            if (Math.abs(window.pageYOffset - targetPosition) > 1) {
                scrollToTarget(targetElement, headerHeight);
            } else {
                clearInterval(intervalId); // 到達したらインターバルをクリア
            }
        }, 100); // 100msごとにチェックして再スクロール
    };

    const scrollToAnchor = function(event) {
        // no-scroll クラスを持つ場合は処理を中断
        if (this.classList.contains('no-scroll')) {
            return;
        }

        event.preventDefault();
        const targetID = this.getAttribute("href").split('#')[1];
        const targetElement = document.getElementById(targetID);
        if (targetElement) {
            const headerHeight = getHeaderHeight(); // ヘッダーの高さを取得
            ensureScrollPosition(targetElement, headerHeight);
        }
    };

    // すべてのアンカーリンクにクリックイベントを追加
    const anchorLinks = document.querySelectorAll('a[href^="#"]');
    anchorLinks.forEach(link => {
        link.addEventListener("click", scrollToAnchor);
    });

    // ページ読み込み時にハッシュがある場合にスクロール
    if (window.location.hash) {
        const targetID = window.location.hash.substring(1);
        const targetElement = document.getElementById(targetID);
        if (targetElement) {
            const headerHeight = getHeaderHeight(); // ヘッダーの高さを再取得
            ensureScrollPosition(targetElement, headerHeight);
        }
    }
});


})(jQuery);
